import React, {Fragment} from "react";
import {Combobox, Transition} from "@headlessui/react";


const SelectComponent = ({
  value,
  onChange,
  children,
  data,
  searchQuery,
  setSearchQuery,
  labelName,
  displayValue,
  error,
  disabled = false,
}) => {
  return (
    <div className="w-full">
      {labelName && (
        <label className="text-sm font-medium text-gray-700 mb-2 block">
          {labelName}
        </label>
      )}
      
      <Combobox value={value} onChange={onChange} disabled={disabled}>
        <div className="relative w-full">
          <div className={`
            relative w-full h-12
            border border-gray-300 rounded-lg
            bg-white
            transition-all duration-200 ease-in-out
            focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent
            hover:border-gray-400
            ${error ? 'border-red-500 focus-within:ring-red-500' : ''}
            ${disabled ? 'bg-gray-50 cursor-not-allowed' : 'cursor-default'}
          `}>
            <Combobox.Button className="w-full h-full flex justify-between items-center px-4">
              <Combobox.Input
                className={`
                  flex-1 h-full text-sm leading-5 text-gray-900 placeholder-gray-500
                  bg-transparent border-none outline-none
                  ${disabled ? 'cursor-not-allowed text-gray-500' : ''}
                `}
                displayValue={displayValue}
                onChange={(event) => setSearchQuery(event.target.value)}
                placeholder="Search..."
              />

              <div className="flex items-center">
                <svg
                  className="w-5 h-5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </Combobox.Button>
          </div>
          
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setSearchQuery("")}
          >
            <Combobox.Options className="absolute z-40 mt-2 max-h-60 w-full overflow-auto rounded-lg border border-gray-200 bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              {children}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
      
      {error && (
        <div className="flex items-center gap-2 text-red-600 text-sm mt-2">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          <span>{error}</span>
        </div>
      )}
    </div>
  );
};

export default SelectComponent;
